import * as Application from 'expo-application';
import Constants from 'expo-constants';

export const parseClientBuild = (value: unknown): number | null => {
  const parsed = typeof value === 'number'
    ? value
    : typeof value === 'string'
      ? Number(value)
      : Number.NaN;

  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const getRuntimeClientBuild = (
  nativeBuild: unknown = Application.nativeBuildVersion,
  configuredBuild: unknown = Constants.expoConfig?.extra?.clientBuild,
  platformFallbackBuild: unknown = Constants.expoConfig?.android?.versionCode
): number =>
  parseClientBuild(configuredBuild)
  ?? parseClientBuild(nativeBuild)
  ?? parseClientBuild(platformFallbackBuild)
  ?? 0;
